module.exports = __webpack_public_path__ + "img/rush-brand_mark-bk12012021.4352739c.png";